import React, {Component} from 'react'
import {reduxForm, Field, change} from 'redux-form'
import DatePickerFormComponent from './redux-form/DatePickerFormComponent'
import moment from 'moment'
import {connect} from 'react-redux'
import SostaOnlineApiService from '../services/SostaOnlineApiService'

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
}

class BackOfficeUserDetailParkingPassForm extends Component {
  constructor (props) {
    super(props)
    this.state = {
      quantity: 1,
      selectedParkTicketType: undefined,
      selectedStartDate: undefined,
      vehicles: [''],
      selectedTotalPrice: 0
    }

    this.onParkTicketTypeSelected = this.onParkTicketTypeSelected.bind(this)
    this.onAddQuantity = this.onAddQuantity.bind(this)
    this.onRemoveQuantity = this.onRemoveQuantity.bind(this)
    this.onVehicleChange = this.onVehicleChange.bind(this)
  }

  onParkTicketTypeSelected (event) {
    let result = this.props.parkTicketTypes.filter(item => item.id === parseInt(event.target.value))
    const totalPrice = result.length > 0 ? result[0].price : 0
    this.setState({
      selectedParkTicketType: result[0],
      selectedTotalPrice: totalPrice
    })
    this.props.dispatch(change('backofficeUserDetailParkingPass', `total`, totalPrice))
    this.props.dispatch(change('backofficeUserDetailParkingPass', `circolazione`, result[0].circolazione))
    this.props.dispatch(change('backofficeUserDetailParkingPass', `periodo`, result[0].periodo))
    this.props.dispatch(change('backofficeUserDetailParkingPass', `sosta`, result[0].sosta))
    this.props.dispatch(change('backofficeUserDetailParkingPass', `color`, result[0].color))
    console.log(result[0])

  }

  onAddQuantity () {
    /*if (this.state.quantity >= 99) {
      return
    }*/

    if (this.state.quantity >= 3) {
      return
    }

    const newQuantity = this.state.quantity + 2
    const totalPrice = this.state.selectedParkTicketType.price * newQuantity

    this.props.dispatch(change('backofficeUserDetailParkingPass', 'quantity', newQuantity))
    this.props.dispatch(change('backofficeUserDetailParkingPass', 'total', totalPrice))

    this.setState({
      quantity: newQuantity,
      selectedTotalPrice: totalPrice
    })
  }

  onRemoveQuantity () {
    if (this.state.quantity <= 1) {
      return
    }

    const newQuantity = this.state.quantity - 2
    const totalPrice = this.state.selectedParkTicketType.price * newQuantity


    this.props.dispatch(change('backofficeUserDetailParkingPass', 'quantity', newQuantity))
    this.props.dispatch(change('backofficeUserDetailParkingPass', 'total', totalPrice))

    this.setState({
      quantity: newQuantity,
      selectedTotalPrice: totalPrice
    })
  }

  onVehicleChange (e, index) {
    let newVehicles = [...this.state.vehicles]
    newVehicles[index] = e.target.value
    this.setState({vehicles: newVehicles})
  }

  render () {
    const {error, handleSubmit} = this.props
    const {selectedParkTicketType} = this.state
    return (
        <form onSubmit={handleSubmit}>
          <div className="box">
            <div className="row">
              <div className="col-md-6 text-left">
                <label>Seleziona tipo Abbonamento</label>
                <Field onChange={this.onParkTicketTypeSelected} name="typeId" className="form-control" component="select" required>
                  <option value={''}>Seleziona tipo Abbonamento</option>
                  {this.props.parkTicketTypes.map(item =>
                      <option key={item.id} value={item.id}>{item.label}</option>)}
                </Field>
              </div>

              {/*<div className="col-md-6 text-left">
              <label>Seleziona Veicolo</label>
              <Field name="vehicleId" className="form-control" component="select" required={!this.state.selectedParkTicketType}>
                {(!this.props.user.vehicles) && <option value={''}>Questo Utente non ha Veicoli</option>}
                {(this.props.user.vehicles && this.props.user.vehicles.length === 0) && <option value={''}>Questo Utente non ha Veicoli</option>}
                {(this.props.user.vehicles && this.props.user.vehicles.length > 0) &&
                <option value={''}>Seleziona un veicolo</option>}
                {(this.props.user.vehicles && this.props.user.vehicles.length > 0) &&
                this.props.user.vehicles.map((item, index) =>
                  <option key={index} value={item.id}>{item.plate_number + ' - ' + item.VehiclePowerSupply.name}</option>)}
              </Field>
            </div>*/}
            </div>
            <div className="row">
              {(selectedParkTicketType && selectedParkTicketType.MarkTypeId) && <div className="col-md-6 text-left">
                <label>Seleziona Contrassegno</label>
                <Field name="markId" className="form-control" component="select" >
                  {(!this.props.user.marks) && <option value={''}>Questo Utente non ha Contrassegni</option>}
                  {(this.props.user.marks && this.props.user.marks.length === 0) && <option value={''}>Questo Utente non ha Contrassegni</option>}
                  {(this.props.user.marks && this.props.user.marks.length > 0) &&
                  <option value={''}>Seleziona Contrassegno</option>}
                  {(this.props.user.marks && this.props.user.marks.length > 0) &&
                  this.props.user.marks.map(item =>
                      <option value={item.id}>#{item.id + ' ' + item.MarkType.label}</option>)}
                </Field>
              </div>}
              {(selectedParkTicketType && selectedParkTicketType.Categories.length > 0) && <div className="col-md-6 text-left">
                <label>Seleziona Categoria</label>
                <Field onChange={this.props.onUserCategorySelected} name="categoryId" className="form-control" component="select" required>
                  <option value={''}>Seleziona Categoria Utente</option>
                  {this.props.user.categories.map((item, index) =>
                      <option key={index} value={item.name + '-' + item.id}>{item.label.charAt(0).toUpperCase() + item.label.slice(1)}</option>
                  )}
                </Field>
              </div>}
            </div>

            {(this.state.selectedParkTicketType) && (
                <div className="form-group">
                  <div className="col-md-4 text-left">
                    <label>Circolazione</label>
                    <Field
                        name="circolazione"
                        className="form-control"
                        component="input"
                    />
                  </div>
                  <div className="col-md-4 text-left">
                    <label>Periodo</label>
                    <Field
                        name="periodo"
                        className="form-control"
                        component="input"
                    />
                  </div>
                  <div className="col-md-4 text-left">
                    <label>Sosta</label>
                    <Field
                        name="sosta"
                        className="form-control"
                        component="input"
                    />
                  </div>
                  <Field
                      name="color"
                      component="input"
                      type="hidden"
                  />
                </div>
            )}

            <div>
              {this.state.selectedParkTicketType && (
                  <div className="col-md-12 text-left" style={{marginTop: '10px', marginBottom: '10px'}}>
                    <button
                        type="button"
                        className="btn btn-xs btn-update btn-add-card"
                        onClick={() => {
                          this.setState({
                            vehicles: [...this.state.vehicles, '']
                          }, () => {
                            this.props.dispatch(change('backofficeUserDetailParkingPass', `vehicle${this.state.vehicles.length - 1}`, ''))
                          })
                        }}>
                      Aggiungi Veicolo
                    </button>
                  </div>
              )}

              {this.state.selectedParkTicketType ? this.state.vehicles.map((item, index) => (<div key={index} className="row form-group">
                <div className="col-md-6 text-left">
                  <label>Seleziona {index + 1}° Veicolo</label>
                  <Field onChange={(e) => this.onVehicleChange(e, index)} name={'vehicle' + index} className="form-control" component="select" required>
                    {(!this.props.user.vehicles) && <option value={''}>Questo Utente non ha Veicoli</option>}
                    {(this.props.user.vehicles && this.props.user.vehicles.length === 0) && <option value={''}>
                      Questo Utente non ha Veicoli
                    </option>}
                    {(this.props.user.vehicles && this.props.user.vehicles.length > 0) &&
                    <option value={''}>Seleziona un veicolo</option>}
                    {(this.props.user.vehicles && this.props.user.vehicles.length > 0) &&
                    this.props.user.vehicles.map(item =>
                        <option key={item.id} value={item.id}>
                          {item.plate_number + ' - ' + item.VehiclePowerSupply.name}
                        </option>)}
                  </Field>
                  <button
                      onClick={() => this.setState({vehicles: this.state.vehicles.filter((_, i) => i !== index)})}
                      type="button"
                      className="btn btn-xs btn-danger">
                    Rimuovi Veicolo
                  </button>
                </div>
              </div>)) : null}


            </div>

            <div className="row">
              <div className="col-md-6 text-left">
                <label>Mese di Validità</label>
                <Field onDateChange={(date) => this.setState({selectedStartDate: moment(date)})} component={DatePickerFormComponent} name="startDate" placeholder="Inizio Validità" className="resident-login" required />
              </div>

              {(this.state.selectedParkTicketType && this.state.selectedStartDate) && <div className="col-md-6 text-left">
                <label>Validità</label>
                <div style={{marginTop: 12}}>
                  <h4>
                    {
                      this.state.selectedParkTicketType.monthly ? (
                          moment(this.state.selectedStartDate).startOf('month').format('L') +
                          ' - ' +
                          moment(this.state.selectedStartDate).add(this.state.quantity > 1 ? this.state.quantity - 1 : 0, 'months').endOf('month').format('L')
                      ) : this.state.selectedParkTicketType.halfYearly
                          ? moment(this.state.selectedStartDate).add(179 * this.state.quantity + (this.state.quantity - 1), 'days').format('L')
                          : this.state.selectedParkTicketType.daily
                              ? moment(this.state.selectedStartDate).add(1 * this.state.quantity, 'days').format('L')
                              : moment(this.state.selectedStartDate).add(6 * this.state.quantity + (this.state.quantity - 1), 'days').format('L')
                    }
                  </h4>
                </div>
              </div>}
            </div>

            <div className="row">
              <div className="col-md-6 text-left">
                <label>Numero di mensilità:</label>
                <div className="input-group" style={{marginBottom: '10px'}}>
                <span className="input-group-btn">
                  <button onClick={this.onRemoveQuantity} type="button" className="btn btn-default btn-number">
                    <span className="glyphicon glyphicon-minus">{}</span>
                  </button>
                </span>
                  <Field onChange={(e) => this.setState({quantity: parseInt(e.target.value)})} component="input" type="text" name="quantity" className="form-control" style={{padding: '6px', verticalAlign: 'middle', display: 'inline-block', textAlign: 'center', zIndex: '0'}} required />
                  <span className="input-group-btn">
                  <button onClick={this.onAddQuantity} type="button" className="btn btn-default btn-number">
                    <span className="glyphicon glyphicon-plus">{}</span>
                  </button>
                </span>
                </div>
              </div>

              {(this.state.selectedParkTicketType && this.state.quantity > 0) && (
                  <div className="col-md-6 text-left">
                    <label>Prezzo</label>
                    <div className="input-group" style={{marginBottom: 12}}>
                      <div className="input-group-addon">€</div>
                      <Field
                          name="total"
                          component="input"
                          type="number"
                          className="form-control"
                          onChange={e => {
                            if (!e.target.value) {
                              this.setState({selectedTotalPrice: 0})
                              this.props.dispatch(change('backofficeUserDetailParkingPass', `total`, 0))
                            } else {
                              this.setState({selectedTotalPrice: e.target.value})
                              this.props.dispatch(change('backofficeUserDetailParkingPass', `total`, e.target.value))
                            }
                          }}
                      />
                    </div>
                  </div>
              )}
            </div>

            {(selectedParkTicketType && this.state.selectedTotalPrice > 0) && (
                <div className="row">
                  <div className="col-md-6 text-left">
                    <label>Totale</label>
                    <div style={{marginTop: 12}}>
                      <h4>€ {Number(this.state.selectedTotalPrice).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h4>
                    </div>
                  </div>
                </div>
            )}

            {selectedParkTicketType && this.state.selectedTotalPrice > 0 && (
                <div className="row">
                  <div className="col-md-6 text-left">
                    <label>Metodo di Pagamento</label>
                    <div className="radio">
                      <label><Field component="input" type="radio" name="method" value="SPORTELLO_POS" required /> POS</label>
                    </div>
                    <div className="radio">
                      <label><Field component="input" type="radio" name="method" value="SPORTELLO_CONTANTI" required /> CONTANTI</label>
                    </div>
                  </div>
                </div>
            )}

            {this.props.loading && <div className="well">Creazione Abbonamento in Corso...</div> }

            {this.props.parkTicketCreateError && <div className="panel panel-danger">
              {this.props.parkTicketCreateError}
            </div>}

            {this.props.parkTicketSuccess && <div className="panel panel-success">
              Acquisto Abbonamento Generato Correttamente
            </div>}
            <p>
              <button type="submit" className="btn btn-lg btn-green">
                Genera Acquisto Abbonamento
              </button>
            </p>
          </div>
        </form>
    )
  }
}

BackOfficeUserDetailParkingPassForm = reduxForm({
  form: 'backofficeUserDetailParkingPass',
  enableReinitialize: true
})(BackOfficeUserDetailParkingPassForm)

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeUserDetailParkingPassForm)



// WEBPACK FOOTER //
// ./src/components/BackOfficeUserDetailParkingPassForm.js